<app-features-container
  *ngIf="dhw$ | async | ready"
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  header="{{ '+INSTALLATIONS.INSTALLATION.PANEL.WARM_WATER' | translate }}"
  [overlayType]="availableOverlays.Dhw"
>
  <div header class="flex flex-row gap-[4px]">
    <ng-container *ngIf="devicesStore.isDhwAvailable$ | async as dhwAvailable">
      <ng-container *ngIf="getDhwStatus$ | async as dhwPillStatus">
        <ng-container *ngIf="dhwPillStatus === DHW_SCHEDULE_LEVEL.On">
          <app-pill data-at-dhw-chip [type]="pillType.success">
            {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PUMP_ON_CHIP' | translate }}
          </app-pill>
        </ng-container>
        <ng-container *ngIf="dhwPillStatus === DHW_SCHEDULE_LEVEL.Off">
          <app-pill data-at-dhw-chip [type]="pillType.secondary">
            {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PUMP_OFF_CHIP' | translate }}
          </app-pill>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="dhwHygiene$ | async as dhwHygiene">
      <app-pill
        *ngIf="dhwHygiene.properties?.active?.value"
        data-at-dhw-hygiene-chip
        type="{{ pillType.success }}"
      >
        {{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.HYGIENE_ACTIVE_CHIP' | translate }}
      </app-pill>
    </ng-container>
  </div>

  <!-- optimization recommendations wide tile -->
  <app-optimization-recommendation
    *ngIf="(recommendationForDhw$ | async).length > 0"
    [recommendationName]="recommendationTileName.dhw"
    data-at-cascade-dhw-optimizations
    feature
    notDraggableContent
    [title]="'+INSTALLATIONS.INSTALLATION.OPTIMIZATION_RECOMMENDATION.TILE_HEADER' | translate"
    [description]="
      '+INSTALLATIONS.INSTALLATION.OPTIMIZATION_RECOMMENDATION.DHW_DESCRIPTION' | translate
    "
  ></app-optimization-recommendation>

  <!-- heating.cascade.dhw.mode -->
  <!-- show only for lead device -->
  <app-feature-tile
    *ngIf="
      (devicesStore.selectedDevice$ | async)?.isLeadDeviceInCascades && cascadeDhwMode$
        | async
        | ready as feature
    "
    data-at-cascade-dhw-mode
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.CASCADE.DHW.MODE' | translate }}"
    [value]="feature | value2: featurePropertyKey.value"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.dhw.sensors.temperature.hotWaterStorage -->
  <!-- TOTO - CHECK if the VALUE was DROPPED, or it is wiki issue -->
  <!-- https://dc-wiki.viessmann.io/wiki/index.php/Production:_heating.dhw.sensors.temperature.hotWaterStorage.bottom -->
  <!-- https://dc-wiki.viessmann.io/wiki/index.php/Production:_heating.dhw.sensors.temperature.hotWaterStorage.top -->
  <app-feature-tile
    *ngIf="storageTankSensor$ | async | ready as feature"
    data-at-dhw-current-temp
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_CURRENT_TEMPERATURE' | translate"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- heating.dhw.temperature.main -->
  <app-feature-tile
    *ngIf="dhwTemperature$ | async | ready as feature"
    data-at-dhw-target-temp1
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SET_TEMPERATURE' | translate"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- DHW Schedule Mode -->
  <!-- show only for ecotronic device -->
  <app-feature-tile
    *ngIf="(devicesStore.isEcotronicDevice$ | async) && dhwScheduleMode$ | async | ready as feature"
    data-at-dhw-schedule-mode
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_SCHEDULE_MODE' | translate"
    [value]="feature | value2: featurePropertyKey.value | translateDhwScheduleMode"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- active operating program -->
  <app-feature-tile
    *ngIf="dhwActiveOperatingMode$ | async | ready as feature"
    data-at-dhw-active-operating-mode
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.DHW_ACTIVE_OPERATING_MODE' | translate"
    [value]="feature | value2: featurePropertyKey.value | translateDhwOperatingMode"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.dhw.dryContact -->
  <app-feature-tile
    *ngIf="dhwDryContact$ | async | ready as feature"
    data-at-dhw-aquastat
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_AQUASTAT' | translate"
    [value]="
      feature.properties?.active?.value
        | booleanSuffix
          : [
              customTranslationsService.AQUASTAT_STATE.active | translate,
              customTranslationsService.AQUASTAT_STATE.inactive | translate
            ]
    "
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- heating.dhw.pumps.circulation -->
  <app-feature-tile
    *ngIf="dhwPumpStatus$ | async | ready as feature"
    data-at-dhw-pump-chip
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_CIRCULATION_PUMP' | translate"
    [value]="feature | ready | value2: featurePropertyKey.status | translateState"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
</app-features-container>
